export class TradeDto {
  tradeId: number;
  accountId: string;
  displayName: string;
  isBuy: boolean;
  ccy1: string;
  ccy2: string;
  ccy1Amount: number;
  ccy2Amount: number;
  dealtRate: number;
  sessionDate: number;
  executionTime: number;
  extSourceRef: string;
  instrumentId: string;
  valueDate: number;
  execId: string;
  swapPrice: number;

  constructor(tradeid: number, accountId: string, displayname: string, isbuy: boolean, ccy1code: string, ccy2code: string, amtccy1: number, amtccy2: number, dealtrate: number, sessiondate: number, executiontime: number, extsourceref: string, instrumentid: string, valuedate: number, execid: string, swapprice: number) {
    this.tradeId = tradeid;
    this.accountId = accountId;
    this.displayName = displayname;
    this.isBuy = isbuy;
    this.ccy1 = ccy1code;
    this.ccy2 = ccy2code;
    this.ccy1Amount = amtccy1;
    this.ccy2Amount = amtccy2;
    this.dealtRate = dealtrate;
    this.sessionDate = sessiondate;
    this.executionTime = executiontime;
    this.extSourceRef = extsourceref;
    this.instrumentId = instrumentid;
    this.valueDate = valuedate;
    this.execId = execid;
    this.swapPrice = swapprice;
  }
}
